/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */
import { InMemoryCache } from 'apollo-cache-inmemory';

export default () => {
  return new InMemoryCache({
    cacheRedirects: {
      Query: {
        // Create cache key redirect for our id format - "Program:Program:1"
        node: (_, args, { getCacheKey }) => getCacheKey({ __typename: args.id.split(':')[0], id: args.id }),
      },
    },
  });
};
